import { shuffle } from 'lodash';
import Alternative from '../model/alternative';

export const mountAlternativeId = (id: number) => {
  return `alternative-${id}`;
};

export const shuffleAlternatives = (alternatives: Alternative[]) => {
  return shuffle(alternatives).map((alternative, index) => {
    alternative.setIndex(index);
    return alternative;
  });
};
